<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            <router-link :to="{ name: 'configuracion-carta' }"> {{ $t('configuracionCarta') }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            {{ $t('materiasPrimasCarta') }}
                        </li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-5">
                            <div class="form-group">
                                <label for="listBusiness"><strong>{{ $t("negocio") }}</strong></label>
                                <el-select class="select-default" size="large" v-model="idBusiness" filterable
                                    @change="permisoCarta()" :placeholder="this.$i18n.t('seleccionaNegocio')">
                                    <el-option v-for="business in listBusinesses" class="select-primary"
                                        :value="business.id" :label="business.establishmentName" :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <!--TABLA DE GESTION DE CONFIGURACION DE CARTA-->
            <template v-if="permiso === 1">

            </template>
            <template v-else-if="permiso && respuesta && !esSelfi">

                <div class="col-md-3">
                    <div class="form-group">

                        <router-link :to="{ name: 'materia-prima-carta', params: { idBusiness: idBusiness } }">
                            <button class="btn btn-primary"><i class="fa fa-plus-square"></i>
                                {{ $t('agregarMateriasPrimas') }}
                            </button>
                        </router-link>
                        <!-- <button class="btn btn-warning" @click="getBusinessReplicado">
                            <i class="far fa-clone"></i>
                            {{$t('replicarMateriasPrimas')}}
                        </button> -->
                    </div>
                </div>

                <div class="col-md-3 text-right">
                    <div style="margin-top: 4px;" class="form-group justify-content-center">
                        <el-checkbox class="form-group" v-model="baja" @change="changeIsDeBaja()">
                            <strong>{{ $t("buscarSubProductoBaja") }}</strong>
                        </el-checkbox>
                    </div>
                </div>

                <div class="col-md-5 text-right">
                    <div class="input-group">
                        <input type="text" class="form-control" v-bind:placeholder="$t('buscar')" v-model="searchQuery"
                            @keyup.enter.prevent="searchMateriasPrimasCarta()">
                        <div class="input-group-append">
                            <button class="btn btn-secondary" type="button" @click="searchMateriasPrimasCarta()"><i
                                    class="fa fa-search"></i>
                            </button>
                            <button class="btn btn-secondary" type="button" @click="removeProductoCarta()"><i
                                    class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class=" table-responsive">
                        <table class="table table-bordered table-striped">
                            <thead class="thead-dark">
                                <tr>    
                                    <th>{{ $t('nombre') }}</th>
                                    <th>{{ $t('nombreTpv') }}</th>
                                    <th width="20%">{{ $t('acciones') }}</th>
                                </tr>
                            </thead>
                            <tbody is="draggable" tag="tbody" @end="onDragEnd">
                                <tr v-for="obj in listMateriasPrimas">
                                    <td>
                                        <span
                                            v-bind:style="[!obj.noDisponible ? { 'text-decoration': 'line-through' } : {}]">{{
                                                    obj.name
                                            }}</span>
                                        <span style="color: red" v-if="obj.baja">
                                            [{{ $t("BAJA") }}]
                                        </span>
                                    </td>
                                    <td>
                                        <span
                                            v-bind:style="[!obj.noDisponible ? { 'text-decoration': 'line-through' } : {}]">{{
                                                    obj.nameRefTpv
                                            }}</span>
                                    </td>
                                    <td align="center">
                                        <!-- Traducir la materia prima a otros idiomas. Se muestra un ícono de globo si el control de idiomas está habilitado
                                        en la configuración (configcarta.controlIdiomas). -->
                                        <div class="btn btn-link btn-xs" 
                                        v-tooltip.top-center="$t('tolTipIdiomaMateriaPrima')" 
                                        :key="configcarta.toString()"
                                        @click="abrirModal(obj)"
                                        v-if="configcarta.controlIdiomas">
                                        <i class="fas fa-globe-americas" style="color: #1f51ff"></i>
                                        </div>
                                                                                
                                        <!-- Editar la materia prima. Botón que redirige al formulario de edición del producto en la carta -->
                                        <div class="btn btn-warning btn-link btn-xs">
                                            <router-link
                                                :to="{ name: 'materia-prima-carta', params: { idBusiness: idBusiness, idMateriaPrima: obj.id } }">
                                                <i style="color: orange" v-tooltip.top-center="$i18n.t('editar')"
                                                    class="fas fa-pencil-alt"></i>
                                            </router-link>
                                        </div>

                                        <!-- Marcar como disponible o no disponible. Checkbox para cambiar el estado de disponibilidad de la materia prima en la carta -->
                                        <div class="btn btn-danger btn-link btn-xs">
                                            <el-checkbox @change="changeNoDisponible(obj.id, obj.noDisponible)"
                                                v-model="obj.noDisponible">
                                                <template></template>
                                                <strong>{{ obj.noDisponible ? $t('disponible') :
                                                        $t('noDisponible')
                                                }}</strong>
                                            </el-checkbox>
                                        </div>

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </template>
            <template v-if="!permiso && !esSelfi">
                <div class="col-md-12">
                    <div class=" alert alert-primary" align="center">
                        <h3><i class="fas fa-exclamation-circle"></i> {{ $t('esteNegocioNoTieneAccesoAEsteModulo') }}.
                        </h3>
                        <span> {{ $t('paraMasInformacionContacteConSu') }} <strong>{{ $t('distribuidor')
                        }}</strong>.</span>
                    </div>
                </div>
            </template>
            <template v-if="esSelfi">
                <div class="col-md-12">
                    <div class="alert alert-primary" align="center">
                    <h3>
                        <i class="fas fa-exclamation-circle"></i>
                        {{ $t("nosmudamos") }}
                    </h3>

                    <div style="margin-bottom: 2vh">                
                        {{$t("noscambiamosaselfi") }}
                        .</div>
                    
                    <!-- <a href="http://127.0.0.1:5173/validate-user" target="_blank">
                        {{ $t("paraContinuar") }}
                        <strong>Selfibar</strong>.
                    </a> -->

                    </div>
                        <button class="btn btn-primary" @click="redirectToSelfibar()">{{$t("irASelfibar")}}</button>

                    </div>
                </template>
        </div>

        <modal name="modalReply" :adaptive=true :scrollable=true height="auto" :clickToClose=false>
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">{{ $t('replicarTodasLasMateriasPrimas') }}</h4>
                </div>
                <div class="modal-body">
                    <input type="checkbox" id="checkSelectAll" name="checkSelectAll" v-model="checkSelectAll"
                        @click="selectAll">
                    <label for="checkSelectAll" class="checkSelectAll">{{ $t("seleccionarTodos") }}</label>

                    <div v-for="business in listBusinessReply">
                        <el-checkbox v-if="business.id != idBusiness" v-model="business.checked" border
                            class="checkbox-element" style="width: 100%">
                            {{ business.establishmentName }}
                        </el-checkbox>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-default" @click="$modal.hide('modalReply')"><i
                            class="fa fa-times-circle"></i> {{ $t("cancelar") }}
                    </button>
                    <button class="btn btn-primary" @click="modalConfirmation"><i class="fa fa-check-circle"></i>
                        {{ $t("aceptar") }}
                    </button>
                </div>
            </div>
        </modal>
        
        <modal name="modalAnadirIdioma" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">
                        {{ $t("traduccionDe") }} {{ materiaPrimaEditar.name }} 
                    </h4>
                </div>

                <div class="modal-body">
                    <!-- Selector de Idioma: cuando se cambia (@change) llama a cambiarTraducciones que mira si hay ya una traduccion pal idioma seleccionado -->
                    <label for="idioma">{{ $t("idioma") }}:</label>
                    <br />
                    <el-select class="select-default" size="large" v-model="selectedLang" @change="cambiarTraducciones"
                    :placeholder="'Selecciona un idioma'">
                        <el-option v-for="lang in langList" class="select-primary" :value="lang.idLang" :label="lang.name" :key="lang.idLang">
                        </el-option>
                    </el-select>
                    <br />

                    <!-- Campo con el input de texto para pintar la traducción recuperada y para editarla -->
                    <div id="ingles" class="mt-3">
                        <label for="traduccion">{{ $t("nombre") }}: </label>
                        <input id="traduccion" class="form-control" type="text" v-model="traduccion" />
                    </div>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-default" @click="$modal.hide('modalAnadirIdioma')"><i
                            class="fa fa-times-circle"></i> {{ $t("cancelar") }}
                    </button>
                    <button class="btn btn-success"  @click="cambiarIdiomaASubproducto(materiaPrimaEditar)">
                        <i class="fa fa-check-circle"></i>
                        {{ $t("guardar") }}
                    </button>
                </div>
            </div>            
        </modal>
    </div>
</template>

<script>
import { DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button, Checkbox } from 'element-ui'
import { Loading } from 'element-ui';
import swal from 'sweetalert2'
import moment from 'moment'
import draggable from 'vuedraggable';

export default {
    name: "MateriasPrimas",
    components: {
        [DatePicker.name]: DatePicker,
        [Select.name]: Select,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Checkbox.name]: Checkbox,
        [Option.name]: Option,
        draggable
    },
    created() {

        this.getBusiness();

    },
    data() {
        return {

            //NEGOCIOS
            listBusinesses: [],
            idBusiness: 0,
            permiso: 1,
            respuesta: false,

            // TRADUCCIÓN
            traduccion: "",
            subproductTranslations: [],
            configcarta: {},           
            langList: [],
            listCartas: [],
            idCarta: 0,
            selectedLang: null, // Aquí se almacenará el idioma seleccionado
            materiaPrimaEditar:{},
            esSelfi: "",


            listMateriasPrimas: [],
            searchQuery: '',

            //LIST BUSINESS COPY
            listBusinessReply: [],
            checkSelectAll: false,
            baja: false


        }
    },
    methods: {

        getBusiness() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                .then(function (response) {

                    if (vm.$store.getters.idBusiness) {
                        vm.idBusiness = vm.$store.getters.idBusiness;
                    }
                    else {
                        vm.idBusiness = response.data.result[0].id;
                    }

                    vm.listBusinesses = response.data.result;

                    vm.permisoCarta();


                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        changeNoDisponible(id, baja) {

            var config = {
                params: {
                    jwt: this.$store.getters.jwt,

                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            var params = {
                idBusiness: this.idBusiness,
                idMateriaPrima: id,
                baja: baja,
                jwt: this.$store.getters.jwt,
            };

            let vm = this;
            let controller = "updateDisponibleMateriaPrima";
            this.axios.post(this.$store.getters.apiUrl + 'delivery/' + controller, params, config)
                .then(function (response) {
                    if (response.data.response) {


                        vm.getMateriasPrimasCarta();

                        let notify = vm.$t("editada");
                        vm.$notify({
                            message: vm.$t('materiaPrima') + " " + notify + ' ' + vm.$t('correctamente'),
                            icon: 'nc-icon nc-check-2',
                            timeout: 2000,
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'success'
                        });

                    } else {
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }
                }).catch(function (error) {
                    console.log(error);
                    vm.inProgress = false;
                });


        },

        permisoCarta() {

             const selectedBusiness = this.listBusinesses.find(
                (business) => business.id == this.idBusiness
            );

            // Saber si es selfi o no 
            if (selectedBusiness && selectedBusiness.selfi === "1") {
                this.esSelfi = true;

                swal({
                    title: this.$t("nosmudamos"),
                    text: this.$t("noscambiamosaselfi"), // Puedes traducir este texto si usas i18n
                    confirmButtonClass: "btn btn-warning btn-fill",
                    type: "warning",
                    showCloseButton: true, // Muestra la "X" en la esquina superior derecha
                    confirmButtonText: this.$t("irASelfibar"), // Texto del botón de confirmación
                    reverseButtons: true, // Invierte los botones para que el botón de confirmación esté primero
                }).then((result) => {
                    // console.log(result);
                    if (result.value) {
                        this.redirectToSelfibar();
                    }
                });
            } else {
                this.esSelfi = false;

            
            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    estado: this.estado
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            this.$store.dispatch("setIdBusiness", this.idBusiness);
            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + 'delivery/getPermisoCarta', config)
                .then(function (response) {
                    if (response.data.response) {

                        // Si hay respuesta, almacenamos y propagamos el valor de listCartas que contiene la info de la carta (permisos de config.controlIdiomas incluido)
                        vm.listCartas = response.data.result.listCartas

                        // Si permiso es true, almacenamos y propagamos el permiso, idCarta y llamamos a getMateriasPrimasCarta(). EL idCarta nos va a servir para 
                        // usarlo como parámetro en varías llamadas a métodos de la API como getLangBusinessInfo() o getMateriasPrimasCarta()
                        if (response.data.result.permiso) {

                            vm.permiso = response.data.result.permiso;
                            vm.idCarta = response.data.result.listCartas[0].id;
                            vm.getMateriasPrimasCarta();


                        } else {

                            vm.permiso = response.data.result.permiso;
                        }

                    } else {
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }

                });
            }

        },

        getMateriasPrimasCarta() {

            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    idCarta: this.idCarta,
                    baja: this.baja

                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.$store.dispatch("setIdBusiness", this.idBusiness);
            this.axios.get(this.$store.getters.apiUrl + "delivery/getMateriasPrimasCarta", config)
                .then(function (response) {
                    if (response.data.response) {

                        vm.listMateriasPrimas = response.data.result;
                        vm.respuesta = true;

                    } else {


                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                        vm.respuesta = false;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            
            const tempconfig = this.listCartas.find((elm) => elm.id == this.idCarta)
                .config;

            if (tempconfig && tempconfig.length > 0) {
                tempconfig.forEach((element) => {
                const el = {};
                el[element.nombre] = element.valor != 0;
                Object.assign(this.configcarta, el);
                //  this.configcarta.push(el)
                });
            }
        },
        searchMateriasPrimasCarta() {


            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    query: this.searchQuery,
                    baja: this.baja
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.$store.dispatch("setIdBusiness", this.idBusiness);
            this.axios.get(this.$store.getters.apiUrl + "delivery/searchMateriasPrimasCarta", config)
                .then(function (response) {
                    if (response.data.response) {

                        vm.activeCarta = vm.searchQuery === '' ? false : true;

                        vm.listMateriasPrimas = response.data.result;

                    }
                })
                .catch(function (error) {
                    console.log(error);
                });


        },
        removeProductoCarta() {

            this.activeCarta = false;
            this.searchQuery = '';
            this.getMateriasPrimasCarta();
        },

        //REPLICADO
        getBusinessReplicado() {

            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            var vm = this;
            this.axios.get(vm.$store.getters.apiUrl + 'general/getBusinessesByUserReplicado', config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.listBusinessReply = response.data.result;
                        vm.$modal.show('modalReply');
                    } else {
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }

                });
        },


        replyMateriasPrimas() {

            var listBuinessReply = this.listBusinessReply.filter(bussines => bussines.checked);

            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            var params = {
                idBusiness: this.idBusiness,
                listBusinesses: listBuinessReply,
                jwt: this.$store.getters.jwt
            };
            this.axios.post(this.$store.getters.apiUrl + 'delivery/replyAllSubproducts', params, config)
                .then(function (response) {

                    vm.$modal.hide("modalReply");

                    // if (response.data.response) {
                    //     vm.closeModal();
                    // } else {
                    //     swal({
                    //         title: `Atención`,
                    //         text: response.data.message,
                    //         confirmButtonClass: 'btn btn-info btn-fill',
                    //         type: 'error'
                    //     });
                    //
                    //
                    // }


                }).catch(function (error) {
                    console.log(error);
                    vm.inProgress = false;
                });

        },

        selectAll() {
            if (this.checkSelectAll) {
                this.listBusinesses.forEach(function (business) {
                    business.checked = false;
                });
            } else {
                this.listBusinesses.forEach(function (business) {
                    business.checked = true;
                });
            }
        },

        modalConfirmation() {
            swal({
                title: this.$t('estasSeguroDeReplicarTodasLasMateriasPrimasALosNegociosSeleccionados'),
                text: this.$t('estaAccionNoSePuedeDeshacer'),
                type: 'info',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                confirmButtonText: this.$t('siReplicar'),
                cancelButtonText: this.$t('cancelar'),
                buttonsStyling: true
            }).then((result) => {
                if (result.value) {
                    this.replyMateriasPrimas();

                }
            })

        },

        changeIsDeBaja() {

            this.getMateriasPrimasCarta()

        },
        abrirModal(materiaPrima) {
            // console.log("estos son los campos de materiaPrima",materiaPrima)
            this.materiaPrimaEditar = materiaPrima;
            this.getIdiomasCarta();
        },
        

        // Ahora mismo no lo uso, se podría usar si necesitamos incluir más acciones al cerrar el modal (por ejemplo, limpiar datos, restablecer variables, o realizar validaciones)
        cerrarModal() {
            this.$modal.hide('modalAnadirIdioma'); // Oculta el modal
        },

        // Al seleccionar un idioma, hacemos un get de las tradcucciones que pueda haber de la materia prima seleccionada. Esto es porque podemos 
        // haber traducido una materia prima anteriormente, y queremos cambiar ahora la traduccion. 
        cambiarTraducciones() {
        let idiomaSeleccionado = this.subproductTranslations.find(
            (element) => element.idLang == this.selectedLang
        );
        
        this.traduccion = idiomaSeleccionado ? idiomaSeleccionado.traduccion : "";
        },

        // Recupera de la API la lista de idiomas disponibles para el negocio:
        // Envía una petición GET al servidor con datos como idBusinessInfo.
        // Si hay idiomas: Llama a getTraducciones() para obtener las traducciones existentes.
        // Si no hay idiomas: Muestra un mensaje de error con swal.
        getIdiomasCarta() {

            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                    idBusinessInfo: this.idCarta,

                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            var vm = this;
            this.axios
            .get(vm.$store.getters.apiUrl + "delivery/getLangBusinessInfo", config)
            .then(function (response) { 
                if (response.data.response) {
                    vm.langList = response.data.result;

                    vm.selectedLang = response.data.result[0].idLang;

                    if (vm.langList.length > 0) {
                        vm.getTraducciones();
                    } else {
                        swal({
                        title: vm.$t("atencion"),
                        text: "Su carta no tiene ningún idioma asociado",
                        confirmButtonClass: "btn btn-info btn-fill",
                        type: "error",
                        });
                    }
                } else {
                    swal({
                        title: vm.$t("atencion"),
                        text: response.data.message,
                        confirmButtonClass: "btn btn-info btn-fill",
                        type: "error",
                    });
                }
            });
        },

        // Obtiene las traducciones existentes para el producto seleccionado.
        // Revisa si hay traducciones para el idioma seleccionado (selectedLang).
        // Carga esas traducciones en las variables traduccion y traduccionDesc.
        // Muestra el modal con las traducciones usando vm.$modal.show("anadir-idioma").
        getTraducciones() {

            //Preparamos las id de los idiomas que vamos a utilizar para buscar las traducciones
            let langIdList = [];

            this.langList.forEach((lang) => {
            langIdList.push(lang.idLang);
            });
            
            // Preparamos params y header, y se añade la autorización con el JWT para que la API reconozca al usuario autenticado.
            var config = {
            params: {
                jwt: this.$store.getters.jwt, 
                langList: langIdList,
                idBusinessInfo: this.idCarta,
                idMateriaPrima: this.materiaPrimaEditar.id,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            // 1.- La peticion con config queda algo así como: 
                //https://api-url/delivery/getLangSubproductCartaTranslations?jwt=abcd1234&langList=[1,2]&idBusinessInfo=10&idMateriaPrima=25
            // 2.- Cuando la API responde, se ejecuta la función then para procesar la respuesta y propagar a nivel de clase el subproductranslations

            var vm = this;
            this.axios
            .get(
                vm.$store.getters.apiUrl + "delivery/getLangSubproductCartaTranslations",
                config
            )
            .then(function (response) {
                if (response.data.response) {

                //Conseguimos las traducciones y seteamos las traducciones del primer idioma que recogimos
                vm.subproductTranslations = response.data.result;

                // Se usa el método find para encontrar el objeto dentro de la lista de traducciones donde idLang coincida con vm.selectedLang
                // Si vm.selectedLang = 2, se obtendrá: idiomaSeleccionado = { idLang: 2, traduccion: "Apple" }
                let idiomaSeleccionado = vm.subproductTranslations.find(
                    (element) => element.idLang == vm.selectedLang
                );

                // Si se encuentra la traducción del idioma seleccionado, se asigna a la variable vm.traduccion. Si no se encuentra, se asigna una cadena vacía ("").
                vm.traduccion = idiomaSeleccionado
                    ? idiomaSeleccionado.traduccion
                    : "";

                vm.$modal.show("modalAnadirIdioma");
                } else {
                swal({
                    title: vm.$t("atencion"),
                    text: response.data.message,
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                });
                }
            });
        },
        
        // Se encarga de actualizar la traducción de una materia prima (subproducto) en el sistema cuando el usuario pulsa el botón de "Guardar".
        // Entrada: Traducción del usuario y objeto de la materia prima.
        // Acción: Enviar la traducción a la API para actualizarla en la base de datos.
        // Salida: Notificación de éxito o error al usuario.
        cambiarIdiomaASubproducto(obj) {

        if (this.traduccion.trim() === "") {
            swal({
            title: "¡Lo sentimos!",
            text: "No puede guardar en blanco la traducción de un producto",
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
            });
        } else {
            //Le añadimos al producto las traducciones
            obj.traduccion = this.traduccion;

            var config = {
            params: {
                jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };
            var params = {
            idBusinessInfo: this.idCarta,
            subproducto: obj,
            jwt: this.$store.getters.jwt,
            idLang: this.selectedLang,
            };

            let vm = this;
            let controller = "cambiarIdiomaASubproducto";
            this.axios
            .post(
                this.$store.getters.apiUrl + "delivery/" + controller,
                params,
                config
            )
            .then(function (response) {
                if (response.data.response) {
                vm.getMateriasPrimasCarta();
                vm.$modal.hide("modalAnadirIdioma");
                let notify = "modificada";
                vm.$notify({
                    message:
                    vm.$t("traduccion") +
                    " " +
                    notify +
                    " " +
                    vm.$t("correctamente"),
                    icon: "nc-icon nc-check-2",
                    timeout: 2000,
                    horizontalAlign: "right",
                    verticalAlign: "top",
                    type: "success",
                });
                } else {
                swal({
                    title: vm.$t("atencion"),
                    text: response.data.message,
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                });
                }
            })
            .catch(function (error) {
                console.log(error);
                vm.inProgress = false;
            });
        }
        },

    redirectToSelfibar() {
        const jwt = this.$store.getters.jwt;

        // Construye la URL con el parámetro JWT
        // const targetUrl = `http://127.0.0.1:5173/validate-user?jwt=${encodeURIComponent(jwt)}`;
        // const targetUrl = `https://dev.selfibar.com/validate-user?jwt=${encodeURIComponent(jwt)}`;
        const targetUrl = `https://selfibar.com/online/validate-user?jwt=${encodeURIComponent(jwt)}`;


        // Abre la URL en una nueva pestaña
        window.open(targetUrl, '_blank');
    },
    
    onDragEnd(event) {
    //   console.log("Índice inicial:", event.oldIndex);
    //   console.log("Índice nuevo:", event.newIndex);
    }
},

    

}

</script>

<style scoped>
tbody tr:hover {
    background-color: rgba(0, 153, 130, 0.2);
    cursor: pointer;
}

td div {
    padding: 12px 8px;
    color: #333;
}

.buttonsSearch:hover {
    cursor: pointer;
    background-color: rgba(0, 153, 130, 0.1);
}

.card {
    padding: 20px;
}

.input-group button {
    height: 40px;
}

.botonTotal {
    border: 1px solid #28a745;
    color: #FFFFFF;
    background-color: #28a745;
    font-weight: 400;
    padding: 8px 16px;
    /* cursor: pointer; */
    margin-bottom: 5px;
    font-size: 14px;
    line-height: 1.42857143;
}

.nombreProducto {
    color: #fff;
    background-color: #0e0e0e;
    text-shadow: 1px 1px #333;
    font-weight: 700;
    font-size: 15px;
}

.tituloPedido {

    color: #1E22AA;
    font-family: "Numier", "Helvetica Neue", Arial;
}

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/MateriasPrimas/MateriasPrimasCarta.vue